import axios from "axios";
import { getCookie } from "./getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getDeleteApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};
export const getDeleteAdminApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(adminApiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
      data: { id: ids },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    const response = await axios.post(adminApiUrl + `user/image_update`, data, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  }
};
